// ** Third Party Components
import styled, { css } from "styled-components";

// #####################################################

export const OuterVideoContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	background-color: transparent;
	width: 100%;
	min-width: 280px;
	height: 100%;
	//min-height: 30vh;
	z-index: 3;

	${({ height }) =>
		height &&
		css`
			height: ${height}px;
		`}
`;

// #####################################################
